import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsCalendarWeekFill } from "react-icons/bs";
import MessageCreation from "../pages/MessageCreation";

const SendMessageModal = ({ visible, close, refresh }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCalendarWeekFill /> Send Message
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MessageCreation
          onComplete={() => {
            close();
          }}
          close={close}
          refresh={refresh}
        />
      </Modal.Body>
    </Modal>
  );
};

export default SendMessageModal;
